export const HIT_TYPE = {
    'CLICK' : '押下',
    'PAGE_VIEW' : 'ページビュー'
};
export const EVENT_CATEGORY = {
    'KOREYOMO' : 'コレヨモ',
    'VIEWER' : 'ビューア'
};
export const EVENT_LABEL = {
    'SITE_TOP' : 'コレヨモ_通常開始',
    'RECOMMEND_PRE' : 'コレヨモ',
    'RECOMMEND_POST' : 'の詳細ページへ',
    'DIAGNOSE' : 'コレヨモ_結果を見る',
    'VIEWER_POST' : '_試し読み開始',
    'RECOMMEND_MODAL' : 'ビューアからおすすめ再チェック',
    'LAST_PAGE_POST' : '_試し読み終了'
};




// WEBPACK FOOTER //
// ./src/constants.js